import Vue from 'vue/dist/vue.esm.js'
import Select2Mixin from '../../mixins/select2_mixin.js.coffee'

Vue.component('document-cluster-form',
  props: ["editableDocumentCluster", "projectPartners"]
  template: JST['document_cluster/form'](),

  created: ->
    if @project_partner_id
      @fetchProjectPartnerDocumentSelect()
      if @editableDocumentCluster
        @associated_document_ids = @editableDocumentCluster.associated_document_ids

  data: ->
    name: if @editableDocumentCluster then @editableDocumentCluster.name else ""
    project_partner_id: if @editableDocumentCluster then @editableDocumentCluster.project_partner_id else null
    associated_document_ids: []
    projectPartnerDocuments: []

  computed:
    associated_documents: ->
      if @associated_document_ids && @associated_document_ids.length != 0
        _.filter(@projectPartnerDocuments, (doc) => @associated_document_ids.indexOf(doc[1].toString()) > -1)
      else
        []

  watch:
    project_partner_id: (oldValue, newValue) ->
      if `oldValue != newValue`
        @associated_document_ids = []
        @projectPartnerDocuments = []
        @fetchProjectPartnerDocumentSelect()

  methods:
    fetchProjectPartnerDocumentSelect: ->
      $.ajax
          dataType: 'JSON',
          url: "/admin/document_clusters/project_partner_available_documents"
          method: 'GET'
          data:
            project_partner_id: @project_partner_id
          success: (data) =>
            @projectPartnerDocuments = data


  components:
    selectTwoSelect: Select2Mixin
)
